<template>
  <div
    class="card1"
    :style="{
      backgroundImage: 'url(' + pageCardTheme.backgroundImage + ')',
      backgroundColor: pageCardTheme.backgroundColor2,
      color: pageCardTheme.color,
    }"
  >
    <div class="card1-gradient">
      <div class="card1-head" ref="cardHeadRef">
        <div
          class="card1-avatar"
          :style="{ backgroundImage: 'url(' + cardInfo.avatar + ')', width: avatarWidth }"
          @click="clickAvatar"
        >
          <img
            v-if="cardInfo.certificateList && cardInfo.certificateList.length"
            class="card1-avatar-authentication"
            src="@shared/assets/images/managerCard/authentication_1.png"
            @click="toggleHandle"
          />
        </div>
        <div class="card1-right">
          <div>
            <div
              class="card1-logo"
              :style="{
                backgroundImage: 'url(' + cardInfo.corpLogo + ')',
              }"
            />
            <div class="card1-name">
              <img
                v-if="globalStore.isManagerView"
                class="card1-edit"
                @click="clickEditBtn"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAABSBJREFUaEPdml1oXEUUx8+ZuXfX3azJJiHR4EONlVobTCurhRYE33wRaZQUQRT1oQ9ixdpojCAEFL9ri4oPPggqgiRgVXzxyRdpQRK0kaS2tKYFoSQhn+5m3b1z58jc/czmbu7c/cTdt+TOOXN+d2bO+c/MRajVb3iCxzrvCEInmAnWZgQskwcxxaSJqLpgFlGKgjJtWnabTAhYBWt69a8UTB61axGC00mlv+Fh4nMDSyEevxHmLGhU4seWKWFH+jb3zfYkJyexYqiKQGLHpsx0V0/EkMlQJcGXsxEslAysLMWnP7vP8uvXH8g4sQNr19oxkAr77chPe0oHN3+P3r4B4yh17bRBDp04F9owOjoCyJmu82rapcmW7WJ9/fzpw0kdP1ogsdGrHZKsNh2HtW7D0ExMv7t73cuvBwjhwbE/uywbg16O6vnc5JT69e29KwBI5frZAYQwdvJyt+QUqGeQur6ZjenpU3uWy8GUBTk4drG72SNRCpkZmbuX3eBdQZq5JrxGqNya2QaistO/Zlenl8NmPr/JWlktzWZbQcaJDSTmehuVYit9GSo1z7btWyyuM1tADrw4H9UpdjbAzYbBHkHAW3SDISmv2Sk4y0xyzTzSQjTDMKT8WZvl2+X6c4rmmf613N95ECU7ZDTS4xWYggiYxk8AtMurbelzacvjJOlb18VqsjcZ4DOZZ/K4bbm3K7Zla/GlnJzJg9zz6vVOHe2EBnuCIb7nF8IJrwwI4+wEMhwp+NQDUdrsj3d2rSo7B0Sp2Cv9l7SmCTP4S4hwMtvpOSI4rwNVbmoxkz+FgG8BkBMLEXwnkvL5clOwtK875+9aUKrZMR4YX4wENlfadQIqBiGCU1LYH+rYubUxTONhAvgUgLgDAfgzCHxakiV0fabDXRuz471xB2Rw5EKv7n6iViDIjAeQ05cI4CgHRJy2E6nHyeSbuhCqndrPzHywfxFheILf2z+oNa2UYU1ADGM/Q5pAgEg26Mu2hCGw7XwW8gPz2/zMAsaOTYVlNBLVNawWBDnuZoydBYBup0+Cv6XEIyTFDd0YStuxtfgaxkanOiRFtCV6NSDIjD7k8nsEvC0bzLKUcohsulophDNLMJ7AvWMXu0M+ZHrFIJxHOQM1EnsyAwFxSXgUhLhQDYSyTXJK4eDIlV7OhPbBQSUgaNlh3hb8hohiWYg0EX+SRPqXHISq7DyYqew7KQA3aFsaAu9/efZW4WP76heEoWmAIb9AgAczQTg5/zlhiR+Lg0KGjzLOPlb/20kBuKZxsiXGXpvrk4JpbXn9Zi31lo0Q+wQRjmQhiIjGpLC/2rZgiwqt3/rEDEl1BUGDv8EQns0HTfi+LcQZt7fqd6SLfTgg9ZpaLGA8hkQf5dcAweck7NfLLexqQAw1teq12Blno8jwBWdxa+inakCcxV639KvSLcIoEKyQZKe99FM1IE76bWRB3KleVAPiFMRGS5R6rBFHojRFNLrQVDMijmhUPpsh42tVRwoyvokbq621oLDz9FMQt2ysGrHV9RKGiHAIAA5n07X2znPLVlcZN+LwwQumUDzpFRLya6/22w4flEEjjoO8AnNGA+C6ZdkPcYB/vNq7Hgcpo3oe0HkFlYGgBSHkDzoQZQ/onI5a5chUsbTGIXZ2/FviWiE3l1vioicD0yJXbzmYFrgMLSTMZq6ZGl1PF2Ba4oOBPE4rfMJRXJn//x/VlOgMpZpn+i+FgzIV0r2WKJUqTf3MyVU3NfnDs/8Ad8x28HcZEXMAAAAASUVORK5CYII="
              />
              {{ cardInfo.name }}
            </div>
            <div v-if="cardInfo.position" class="card1-position text-ellipsis">{{ cardInfo.position }}</div>

            <div v-if="cardInfo.corpName" class="card1-info text-ellipsis-line-2">{{ cardInfo.corpName }}</div>
            <template v-if="cardInfo.deptList && cardInfo.deptList.length > 0">
              <div v-for="item in cardInfo.deptList" :key="item" class="card1-info text-ellipsis-line-2">
                {{ item }}
              </div>
            </template>
          </div>
          <span
            v-if="
              !state.toggle &&
              ((cardInfo.tagList && cardInfo.tagList.length) ||
                cardInfo.desc ||
                cardInfo.address ||
                (cardInfo.certificateList && cardInfo.certificateList.length) ||
                hasLocalizationCertificate)
            "
            class="cz-iconfont czmingpian-gengduo card1-toggle-down"
            :style="{ color: iconColor }"
            @click="toggleHandle"
          />
          <div class="card1-contact" :style="{ color: iconColor }">
            <span
              v-if="cardInfo.mobile"
              class="cz-iconfont czmingpian-dianhua card1-contact-icon"
              @click="clickMobile"
            />
            <span
              v-if="cardInfo.contact"
              class="cz-iconfont czmingpian-weixin card1-contact-icon"
              @click="clickWechat"
            />
          </div>
        </div>
      </div>
      <template v-if="state.toggle">
        <div class="card1-foot">
          <div class="card1-item" v-if="cardInfo.tagList && cardInfo.tagList.length">
            <span class="cz-iconfont czbiaoqian card1-item-icon" />
            <div class="card1-item-text card1-item-tags">
              <span v-for="(item, index) in cardInfo.tagList" :key="index">
                {{ item }} {{ index < cardInfo.tagList.length - 1 ? '·' : '' }}
              </span>
            </div>
          </div>
          <div v-if="cardInfo.desc" class="card1-item">
            <span class="cz-iconfont czliangdian card1-item-icon" />
            <div class="card1-item-text">
              <p v-for="(item, index) in cardInfo.desc.split('\n')" :key="index">
                {{ item }}
              </p>
            </div>
          </div>
          <div v-if="cardInfo.address" class="card1-item">
            <span class="cz-iconfont czdizhi card1-item-icon" />
            <div class="card1-item-text">{{ cardInfo.address }}</div>
          </div>
          <template v-if="cardInfo.certificateList && cardInfo.certificateList.length">
            <CertificateBanner :certificateList="cardInfo.certificateList" />
          </template>
          <SPDBLocalizationCertificate v-if="hasLocalizationCertificate" />
          <span
            class="cz-iconfont czmingpian-gengduo-shouqi card1-toggle-up"
            :style="{ color: iconColor }"
            @click="toggleHandle"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useBusinessCardStore, useGlobalStore } from '@shared/store';
  import { storeToRefs } from 'pinia';
  import { computed, reactive, ref } from 'vue';
  import CertificateBanner from '../certificate-banner/index.vue';
  import SPDBLocalizationCertificate from '../spdb-localization-certificate/index.vue';
  import { useWechat, useMobile, useAvatar, useCard, useSPDBLocalizationCertificate } from '../../composables';

  const globalStore = useGlobalStore();
  const { clickWechat } = useWechat();
  const { clickMobile } = useMobile();
  const { clickAvatar } = useAvatar();
  const { clickEditBtn } = useCard();
  const { hasLocalizationCertificate } = useSPDBLocalizationCertificate();

  const state = reactive({ toggle: false });

  const cardStore = useBusinessCardStore();

  const { pageCardTheme, pageCardInfo: cardInfo } = storeToRefs(cardStore);

  const iconColor = computed(() => pageCardTheme.value.iconColor);

  const cardHeadRef = ref<HTMLElement>();

  const toggleHandle = (e: Event) => {
    e.stopPropagation();
    state.toggle = !state.toggle;
  };

  const avatarWidth = computed(() => {
    return (cardHeadRef.value?.offsetWidth || 0) * 0.8 + 'px';
  });
</script>

<style lang="less" scoped>
  .card1 {
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: 100%;
    border-radius: 0.1rem;
    box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.15);

    &-gradient {
      background: url('@shared/assets/images/managerCard/gradient.png') no-repeat;
      background-size: 100% 100%;
    }
    &-head {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
    }
    &-avatar {
      position: relative;
      max-width: 2.9rem;
      height: auto;
      max-height: 4.2rem;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 0.06rem 0 0 0.06rem;
      &-authentication {
        position: absolute;
        left: -5.6%;
        bottom: 5.5%;
        width: 80%;
      }
    }
    &-right {
      position: relative;
      padding: 0.2rem 0.2rem 1.05rem 0;
      width: 4rem;
      min-height: 2.4rem;
      text-align: right;
    }
    &-toggle-down {
      position: absolute;
      left: 0.02rem;
      bottom: 0;
      padding: 0.16rem 0.3rem 0.1rem;
      opacity: 0.2;
    }
    &-toggle-up {
      padding: 0.16rem 0.3rem;
      opacity: 0.2;
    }
    &-contact {
      position: absolute;
      right: 0.2rem;
      bottom: 0.1rem;
      &-icon {
        margin-left: 0.2rem;
        font-size: 0.56rem;
      }
    }
    &-logo {
      height: 0.32rem;
      background-position: right 0;
      background-repeat: no-repeat;
      background-size: contain;
    }
    &-name {
      margin: 0.2rem 0 0.2rem;
      font-size: 0.36rem;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    &-edit {
      margin-right: 0.12rem;
      width: 0.5rem;
    }
    &-position {
      margin-top: 0.05rem;
      font-size: 0.22rem;
      font-weight: normal;
      line-height: 0.3rem;
    }
    &-info {
      font-size: 0.22rem;
      line-height: 0.3rem;
    }
    &-foot {
      margin: 0.2rem 0.3rem 0.1rem;
      text-align: center;
    }
    &-item {
      display: flex;
      padding: 0.1rem 0;
      font-size: 0.22rem;
      line-height: 0.3rem;
      text-align: left;
      &-tags {
        display: flex;
        flex-wrap: wrap;
      }
    }
    &-item-icon {
      margin-right: 0.16rem;
      font-size: 0.24rem;
    }
  }
</style>
